import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";
import { IContract, IStore, IIdName, IIdNameGeneric } from '../../../_entities';
import { StringTool } from "../../../core/tools/index";
import * as moment from 'moment';

@Component({
	selector: 'h-calculation-rent-costs-rental-supplements',
	template: require('./h-calculation-rent-costs-rental-supplements.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class CalculationRentCostsRentalSupplementsComponent extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) {
		super(contractService);
	}


	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/h-calculation-rent-costs-rental-supplements.component.ts